import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import { ProtectedRoute, Setup2FARoute } from './components/ProtectedRoute';
import { Login } from './pages/Login';
import { ForgotPassword } from './pages/ForgotPassword';
import { ResetPassword } from './pages/ResetPassword';
import { Setup2FA } from './pages/Setup2FA';
import { Home } from './pages/Home';
import { Payments } from './pages/Payments';
import { CustomerInvoices } from './pages/CustomerInvoices';
import { Reconciliation } from './pages/Reconciliation';
import { Settings } from './pages/Settings';
import { Payroll } from './pages/Payroll';
import { Jobs } from './pages/Jobs';
import { BankFiles } from './pages/BankFiles';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/setup-2fa"
              element={
                <Setup2FARoute>
                  <Setup2FA />
                </Setup2FARoute>
              }
            />
            <Route
              path="/home"
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payments"
              element={
                <ProtectedRoute>
                  <Payments />
                </ProtectedRoute>
              }
            />
            <Route
              path="/customer-invoices"
              element={
                <ProtectedRoute>
                  <CustomerInvoices />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reconciliation"
              element={
                <ProtectedRoute>
                  <Reconciliation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/jobs"
              element={
                <ProtectedRoute>
                  <Jobs />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payroll"
              element={
                <ProtectedRoute>
                  <Payroll />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bank-files"
              element={
                <ProtectedRoute>
                  <BankFiles />
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<Navigate to="/payments" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
